// Recursos del juego
export const resources = ['💎', '🪵', '🥩', '🪨'] as const
export const harvest = ['🔥', '🕳', ...resources]

// Sets de emojis por categoría
export const skyelements = ['💫', '🌞', '🌧', '🌚', '🪐', '🌎']
export const elements = ['🌿', '💦', '🔥', '🪵', '💨', '🪨']
export const fruits = ['🍑', '🫐', '🍓', '🥝', '🥥', '🍏', '🍌']
export const organs = ['👀', '🫀', '🫁', '🧠', '👅', '🦴', '👃🏼']
export const flowers = ['🌹', '🌺', '🌸', '🌼', '🌻', '🍀', '🌷']
export const covid = ['😷', '👩🏼‍⚕️', '💉', '🦠', '🧻', '💊']
export const drinks = ['🍺', '🍷', '🧊️', '🍸', '🥃', '🥛', '🍹']
export const vegetables = ['🥦', '🥔', '🥕', '🥬', '🌽', '🥑', '🍆', '🍅']
export const field = ['🌾', '🌻', '🌱', '🌿', '🌺', '🌷', '🌼', '🌸']
export const clockhours = ['🕒', '🕕', '🕜', '🕦', '🕐', '🕢']
export const horoscope = ['♈️', '♉️', '♊️', '♋️', '♌️', '♍️', '♎️', '♏️']
export const handsigns = ['👌', '🙌', '🤞', '🤘', '🤙', '👍', '✌️', '🖖', '🤟', '☝️']

// Animales
export const cuteAnimals = ['🐶', '🐱', '🐹', '🐻', '🐼', '🐨', '🐸', '🐷']
export const roughAnimals = ['🐗', '🐅', '🐺', '🦁', '🦊', '🦣', '🦧', '🦏', '🐯', '🐆']
export const waterAnimals = ['🐙', '🐳', '🐬', '🦈', '🐟', '🐡', '🦞', '🦐', '🐠', '🦭']
export const hugeAnimals = ['🦖', '🦍', '🦧', '🐘', '🦏', '🦣', '🦬', '🐉', '🦛', '🦒']
export const insects = ['🐝', '🐞', '🪰', '🪲', '🦋']
export const invert = ['🦟', '🪱', '🐛', '🐜']
export const reptiles = ['🐍', '🦂', '🦎', '🐊', '🦐', '🦞']
export const rodents = ['🐀', '🐁', '🦫', '🦡', '🐿', '🦔', '🦝']

// Otros sets
export const clothing = ['🥼', '👚', '👖', '🩳', '👗', '👙', '👔', '🧥', '🦺', '👕']
export const party = ['🥳', '💃', '🕺', '🥂', '🎶', '🎈', '🎊', '🎉', '🎈', '🪅']
export const sweet = ['🍦', '🍪', '🍰', '🍩', '🧁', '🍬', '🍫', '🍨', '🥧', '🍭']
export const summer = ['😎', '☀️', '🌞', '👙', '🍉', '🕶', '⛱', '🩳', '🧴', '🏝']
export const holidays = ['👑', '❤️', '🌸', '🐰', '🎃', '👻', '☀️', '⛱', '🎊', '🎅']
export const winter = ['🥶', '❄️', '⛷', '☃️', '🌨', '🧣', '⛄️', '🧦', '🏂', '⛸']
export const colorful = ['💩', '☎️', '🎀', '⭐️', '🔥', '💎', '🧿', '🔋', '🔮', '📷']
export const professions = ['👮', '👷', '🕵️', '🧑‍🌾', '🧑‍🍳', '🧑‍🏫', '🧑‍💻', '🧑‍🔧', '🧑‍🔬', '🧑‍🎨']
export const activities = ['🧗', '⛷️', '🏌️', '🚣', '🏇', '⛹️', '🏋️', '🤾', '🚴', '🏊']
export const sportballs = ['⚽️', '🏀', '🏈', '🎾', '⚾️', '🎱', '🏐']

// Sets para juegos de memoria
export const cloudymood = ['🌤', '⛅️', '🌧', '🌦', '🌩']
export const filmset = ['🎥', '📽', '📷', '📸', '📹']
export const pokerset = ['♠️', '♣️', '♥️', '♦️', '🃏']
export const randomhats = ['👒', '🧢', '🎩', '⛑', '👑', '🎓']
export const shoes = ['👠', '👢', '👟', '🩴', '🥾', '🥿']
export const colorfullbooks = ['📙', '📘', '📗', '📕', '📔', '📓']
export const dayNight = ['🌑', '🌒', '🌓', '🌔', '🌕', '🌖', '🌗', '🌘']

/** Equipo de buceo - para Memoji Open Water */
export const divingEquipment = ['🤿', '🥽', '🦺', '👂', '🦶', '🐠', '🦐', '🐙']

// Personajes del jugador
export const characters: Record<string, string[]> = {
  '🚹': ['👶🏻', '🧒🏻', '🧔🏻', '👨🏼‍🌾', '🧝', '💂🏽‍♂️', '🥷🏻', '🧙', '🤴🏻', '🧑‍🚀'],
  '🚺': ['👶🏼', '👧🏼', '👩🏼', '👩🏼‍🌾', '🧝‍♀️️️', '🧚‍♀️', '🧙🏼‍♀️', '🦹🏼‍♀️️️️', '👸🏼', '👽'],
}

// Tipos
export type EmojiSet = string[]
export type ResourceType = typeof resources[number]
